import * as Types from '../../gql/types2';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {"context":{"clientName":"graphql2"}} as const;
export type SearchCustomRollupInvoicesQueryVariables = Types.Exact<{
  input: Types.CustomRollupInvoiceSearchArgsInput;
}>;


export type SearchCustomRollupInvoicesQuery = { __typename?: 'QueryModel', customRollupInvoices: { __typename?: 'CustomRollupInvoiceQueryModel2', search: { __typename?: 'ConnectionOfCustomRollupInvoice', token?: string | null, records: Array<{ __typename?: 'CustomRollupInvoice', invoiceNumber: string, state: Types.InvoiceState, total: number, invoiceDate?: string | null, cancelledDate?: string | null, projectGroup: { __typename?: 'ProjectGroup', name: string, customer: { __typename?: 'Customer', name: string, number?: string | null }, projects: Array<{ __typename?: 'Project', name: string, number: number }> }, lineItems: Array<{ __typename?: 'CustomRollupInvoiceLineItem', total: number, invoice: { __typename?: 'Invoice', projectNumber: number } }> }> } } };


export const SearchCustomRollupInvoicesDocument = gql`
    query SearchCustomRollupInvoices($input: CustomRollupInvoiceSearchArgsInput!) {
  customRollupInvoices {
    search(input: $input) {
      token
      records {
        invoiceNumber
        state
        total
        invoiceDate
        cancelledDate
        projectGroup {
          name
          customer {
            name
            number
          }
          projects {
            name
            number
          }
        }
        lineItems {
          total
          invoice {
            projectNumber
          }
        }
        invoiceDate
      }
    }
  }
}
    `;

/**
 * __useSearchCustomRollupInvoicesQuery__
 *
 * To run a query within a React component, call `useSearchCustomRollupInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCustomRollupInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCustomRollupInvoicesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchCustomRollupInvoicesQuery(baseOptions: Apollo.QueryHookOptions<SearchCustomRollupInvoicesQuery, SearchCustomRollupInvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchCustomRollupInvoicesQuery, SearchCustomRollupInvoicesQueryVariables>(SearchCustomRollupInvoicesDocument, options);
      }
export function useSearchCustomRollupInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchCustomRollupInvoicesQuery, SearchCustomRollupInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchCustomRollupInvoicesQuery, SearchCustomRollupInvoicesQueryVariables>(SearchCustomRollupInvoicesDocument, options);
        }
export type SearchCustomRollupInvoicesQueryHookResult = ReturnType<typeof useSearchCustomRollupInvoicesQuery>;
export type SearchCustomRollupInvoicesLazyQueryHookResult = ReturnType<typeof useSearchCustomRollupInvoicesLazyQuery>;
export type SearchCustomRollupInvoicesQueryResult = Apollo.QueryResult<SearchCustomRollupInvoicesQuery, SearchCustomRollupInvoicesQueryVariables>;